import React from 'react';
import clsx from 'clsx';
import styles from './PageHeader.css';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
}

const PageHeaderLeft = ({ className, children, ...others }: Props) => {
    return (
        <div className={clsx(styles.leftContainer, className)} {...others}>
            {children}
        </div>
    );
};

export default PageHeaderLeft;
